//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogContent from './dialogContent.vue';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: {
    DialogContent,
  },
  mixins: [viewportMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    basketComputed: {
      type: Array,
      default: () => [],
    },
    basketGiftItems: {
      type: Array,
      default: () => [],
    },
    basketPromocodeItems: {
      type: Array,
      default: () => [],
    },
    addPromocodeCourses: {
      type: Function,
      default: () => {},
    },
    clearFreeCourses: {
      type: Function,
      default: () => {},
    },
    clearBasket: {
      type: Function,
      default: () => {},
    },
    removeFromBasketEvent: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    display: {
      get() {
        return this.$store.state.sale.basketDialog;
      },
      set(payload) {
        this.$store.commit('sale/setBasketDialog', payload);
      },
    },
    basket: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
